<template>
    <section>
        <div class="hero ">
            <div class="hero-body background-light">
                <div class="container">
                    <h1 class="title is-size-1-desktop is-size-2-mobile has-text-centered">Sign in</h1>
                </div>
            </div>
        </div>

        <div class="hero is-small background-primary">
            <div class="hero-body">
            </div>
        </div>

        <div class="hero">
            <div class="hero-body background-light">
                <div class="container">
                    <!-- The surrounding HTML is left untouched by FirebaseUI.
                       Your app may use that space for branding, controls and other customizations.-->
                    <!--<h1>Welcome to My Awesome App</h1>-->
                    <div id="firebaseui-auth-container"></div>
                    <div id="loader">Loading...</div>
                    {{user}}
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import firebase from 'firebase/app'
import firebaseui from 'firebaseui'
import 'firebaseui/dist/firebaseui.css'

export default {
  name: 'SignIn',
  mounted () {
    let redirectTo = this.$route.query.redirect
    const uiConfig = {
      callbacks: {
        signInSuccessWithAuthResult: (authResult, redirectUrl) => {
          // User successfully signed in.
          // Return type determines whether we continue the redirect automatically
          // or whether we leave that to developer to handle.
          return true
        },
        uiShown: () => {
          // The widget is rendered.
          // Hide the loader.
          document.getElementById('loader').style.display = 'none'
        }
      },
      // Will use popup for IDP Providers sign-in flow instead of the default, redirect.
      signInFlow: 'popup',
      signInSuccessUrl: redirectTo || '/admin',
      signInOptions: [
        // Leave the lines as is for the providers you want to offer your users.
        firebase.auth.GoogleAuthProvider.PROVIDER_ID
      ]
      // Terms of service url.
      // tosUrl: '<your-tos-url>',
      // Privacy policy url.
      // privacyPolicyUrl: '<your-privacy-policy-url>'
    }

    // Initialize the FirebaseUI Widget using Firebase.
    const ui = new firebaseui.auth.AuthUI(firebase.auth())

    ui.start('#firebaseui-auth-container', uiConfig)
  }
}
</script>

<style scoped lang="scss">

</style>
